import React from "react";
import { Box, Typography, Button } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import { useNavigate } from "react-router-dom";

const AccessDenied = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/dashboard"); // o "/" según tu flujo
  };

  return (
    <Box
      sx={{
        height: "80vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        px: 3,
      }}
    >
      <BlockIcon color="error" sx={{ fontSize: 80, mb: 2 }} />
      <Typography variant="h4" gutterBottom>
        Acceso denegado
      </Typography>
      <Typography variant="body1" sx={{ mb: 4 }}>
        No tienes permisos para acceder a esta sección. Si crees que esto es un error, contacta con el administrador.
      </Typography>
      <Button variant="contained" color="primary" onClick={handleGoHome}>
        Volver al inicio
      </Button>
    </Box>
  );
};

export default AccessDenied;
